module.exports = __webpack_public_path__ + "img/sidebar-bg.1080e429.png";